import "./fullscreenModal.css";
import { html, render } from "lit-html";
import pointerLockEvents from "../helpers/pointerLockEvents.js";
import { customCameraHelpers } from "../babylonScene";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import { JoystickUtils } from "~/src/helpers/virtualJoystick.js";
import { pickText } from "../textcontents";
const buildWindow = function (options) {
  let border = options && options.border;
  let exitCallback = options && options.exitCallback;
  let hidden = options && options.hidden;
  let orientationAlert = options && options.orientationAlert;

  if (!orientationAlert) {
    console.log(customCameraHelpers)
    if (customCameraHelpers && customCameraHelpers.getHelpers().detachControl) {
      customCameraHelpers.getHelpers().detachControl();
    }
  }

  pointerLockEvents.unlockPointerFromCanvas();

  const getOrientationAlertContainer = () => {
    const container = document.getElementById("modal-container-alert");;
    if (!container) { // if it's orientationAlert we create a new one
      const container = document.createElement("div");
      container.id = "modal-container-alert";
      container.classList.add("orientation-alert");
      document.body?.append(container);
      return container;
    } else {
      return container;
    }
  };
  const getContainer = () => {
    const container = document.getElementById("modal-container");
    if (!container) { // if it's orientationAlert we create a new one
      const container = document.createElement("div");
      container.id = "modal-container";
      document?.body?.append(container);
      return container;
    } else {
      return container;
    }
  };

  const container = orientationAlert ? getOrientationAlertContainer() : getContainer();

  const createModal = ({ animated, animation, hidden }) => html`
    <div
      id="fullscreen-modal"
      class="${animated ? `animated ${animation}` : ""}"
      style="display: ${hidden ? "none" : "initial"}"
    >
      <div id="modal-content" class="${border ? "shadow-border" : ""}"></div>
    </div>
  `;

  function exitButtonCallback(event) {
    if (event) {
      event.stopPropagation();
    }
    // this adds the animation classes
    if (customCameraHelpers && customCameraHelpers.getHelpers().attachControl) {
      customCameraHelpers.getHelpers().attachControl();
    }

    if (exitCallback) exitCallback();

    if (mobileOrNot()) {
      JoystickUtils.reveal();
    }

    render(createModal({ animated: false, animation: "zoomOut" }), container);
    setTimeout(() => {
      container.remove();
    }, 600);
    pointerLockEvents.lockPointerToCanvas();
  }

  container.style.display = "flex";

  if (mobileOrNot()) {
    JoystickUtils.hide();
  }

  render(
    createModal({
      animated: false,
      animation: "zoomIn",
      hidden: hidden ? hidden : false,
    }),
    container
  );

  return {
    element: document.querySelector(`${orientationAlert ? "#modal-container-alert" : "#modal-container"} #modal-content`),
    exit: exitButtonCallback,
  };
};

export default buildWindow;
